enum ModuleNotificationTypes {
  Reservations = 'reservations',
  Orders = 'orders',
  Memberships = 'memberships',
  HelpDesk = 'helpDesk'
};

export default ModuleNotificationTypes;
